<template>
  <div :class="$style.container" v-if="recentEventLogs">
    <div :class="$style.titleSection">
      <div :class="$style.title">HISTORY</div>
      <button @click="handleNavigate" class="button" :class="$style.button">
        <span>Go to Activity Log</span>
        <span class="icon">
          <i class="fas fa-chevron-right"></i>
        </span>
      </button>
    </div>

    <p-data-table
      v-if="histories.length === 0"
      :data="histories"
      :hoverable="true"
      :noDataText="`No history found`"
    >
    </p-data-table>
    <template v-else>
      <div :class="$style.contentSection">
        <p-list-item
          v-for="(history, index) in histories"
          :key="`activity${index}`"
          :title="`${history.datetime}`"
        >
          <p v-if="history.eventType === 'ADD_NEW_PARTICIPANT'">
            {{ getUserName(history.eventPayload.originator.oicPayload) }} added
            a new participant
          </p>
          <p v-else-if="history.eventType === 'REMOVE_PARTICIPANT'">
            {{ getUserName(history.eventPayload.originator.oicPayload) }}
            removed participant
          </p>
          <p v-else-if="history.eventType === 'ADD_NEW_CRITERIA'">
            {{ getUserName(history.eventPayload.originator.oicPayload) }} added
            a data collection period criteria
          </p>
          <p v-else-if="history.eventType === 'REMOVE_CRITERIA'">
            {{ getUserName(history.eventPayload.originator.oicPayload) }}
            removed a data collection period criteria
          </p>
          <p v-else-if="history.eventType === 'ADD_FORMER_PROJECT_OWNER'">
            {{ getUserName(history.eventPayload.originator.oicPayload) }}
            has changed project owner
          </p>
        </p-list-item>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import {
  PaginatedProjectEventLogsPayload,
  PaginatedProjectEventLogsResponse,
} from '@/store/modules/projects/types/projects.types';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/utils/date.util';
import { useUserEmail } from '@/utils/user.util';

@Component({
  components: {},
})
export default class ActivityLogList extends Vue {
  @Prop()
  public projectId!: number;

  @Action('projects/getPaginatedEventLogs')
  public getRecentEventLogs!: (
    params: PaginatedProjectEventLogsPayload,
  ) => void;

  @State((state) => state.projects.paginatedEventLogs)
  public recentEventLogs!: PaginatedProjectEventLogsResponse;

  public mounted() {
    this.getRecentEventLogs({
      projectId: this.projectId,
      limit: 10,
      page: 1,
    });
  }

  get histories() {
    if (this.recentEventLogs) {
      return this.recentEventLogs.items
        .filter((log: any) => {
          return log.eventPayload.originator;
        })
        .map((log: any) => {
          const today = dayjs().format(DATE_FORMAT);
          const yesterday = dayjs().add(-1, 'day').format(DATE_FORMAT);
          const dataUpdatedAt = dayjs(new Date(log.eventOccurredAt)).format(
            DATE_FORMAT,
          );

          let dateToDisplay;
          if (dataUpdatedAt === today) {
            dateToDisplay = 'Today';
          } else if (dataUpdatedAt === yesterday) {
            dateToDisplay = 'Yesterday';
          } else {
            dateToDisplay = dataUpdatedAt;
          }

          return {
            ...log,
            // @ts-ignore
            datetime: dateToDisplay,
          };
        });
    }
    return [];
  }

  public getUserName(userInfo: any) {
    const name = userInfo.name;
    const loggedInUserEmail = this.userEmail;
    if (loggedInUserEmail === userInfo.email) {
      return 'You';
    } else {
      return name;
    }
  }

  public handleNavigate() {
    this.$emit('changeActiveTab', '#activityLog');
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 5rem;

  .titleSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      padding: 8px 0;
    }

    .button {
      border: none;
      background: transparent;
      color: $primary;
    }
  }

  .contentSection {
    box-shadow: 0 1px 2px $grey-border, 0 1px 2px $grey-border;
    border: 0.5px solid $grey-border;
    overflow: hidden;
    border-radius: 6px;
    background: white;
  }
}
</style>
